import { isStage } from 'www/utils'
import { createTemplate } from './functions'

if (isStage) {
  const alertTemplate = createTemplate()

  document.body.append(alertTemplate)
}
